module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 149
// module chunks = 0